import { useQuery } from '@tanstack/react-query';

import { getClaimStatusesApi } from 'api/claimStatuses';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ClaimStatusI } from 'declarations/interfaces/claimStatuses';
import type { ApiErrorI } from 'declarations/interfaces/errors';

type ClaimStatusIRequestT = {
  isEnabled: boolean;
  roofTopId: string | undefined;
};

export const useFetchClaimStatuses = (
  params: ClaimStatusIRequestT
): ReturnType<typeof useQuery<ClaimStatusI[], ApiErrorI>> =>
  useQuery<ClaimStatusI[], ApiErrorI>(
    [RequestQueryKeysE.FetchClaimStatuses, params.roofTopId],
    (): Promise<ClaimStatusI[]> => getClaimStatusesApi(params.roofTopId || ''),
    { enabled: params.isEnabled }
  );
